module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Notifications","har skrivit till dig":"has tagged you","på kandidaten":"on the candidate","i jobbet":"on the job"},"sv":{"title":"Aviseringar","har skrivit till dig":"har skrivit till dig","på kandidaten":"på kandidaten","i jobbet":"i jobbet"}}')
  delete Component.options._Ctor
}
